<template>
  <div class="calculator">
    <div class="global__wrapper h-100 align-items-center">
      <div class="row w-100 h-100 m-0 align-items-center justify-content-center">
        <keep-alive>
          <component
            :is="mainData.stepName"
            :mainData="mainData"
            :totalValue="totalValue"
            :volume_parameter="volume_parameter"
            :resultData="resultCalculator"
            @changeParameter="changeParameter"
            @activeForm="chkComponentForm"
            @sumValue="sumValue">
          </component>
        </keep-alive>
        <!--
        ==================
         import close simulation
        ==================
       -->
        <CloseSimulation></CloseSimulation>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSimulation from '@/components/storagecalculator/CloseSimulation.vue'
import StartCalculator from '@/components/storagecalculator/StartCalculator.vue'
import CalcStep1 from '@/components/storagecalculator/CalcStep1.vue'
import CalcStep2 from '@/components/storagecalculator/CalcStep2.vue'
import CalcStep3 from '@/components/storagecalculator/CalcStep3.vue'
import CalcStep4 from '@/components/storagecalculator/CalcStep4.vue'
import CalcStep5 from '@/components/storagecalculator/CalcStep5.vue'
import ResultCalculator from '@/components/storagecalculator/ResultCalculator.vue'

export default {
  name: 'storageCalculator',
  components: {
    CloseSimulation,
    StartCalculator,
    CalcStep1,
    CalcStep2,
    CalcStep3,
    CalcStep4,
    CalcStep5,
    ResultCalculator
  },
  data: () => ({
    mainData: {
      stepName: 'StartCalculator'
    },
    volume_parameter: '',
    totalValue: 0,
    resultCalculator: {
      table: [],
      total: 0
    },
    dataActivity: {
      featureName: '',
      featureStep: 1,
      featureProcess: ''
    },
    payloadLog: {
      featureName: 'STORAGE CALCULATOR',
      featureStep: 0,
      stepName: 'Please Choose Between Two / StartCalculator',
      featureProcess: {
        status: 'success',
        data: {}
      }
    }
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.mainData
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    chkComponentForm (data) {
      Object.assign(this.mainData, data)
      if (data.stepName === 'ResultCalculator') { this.makeTable() }
    },
    sumValue (data) {
      this.totalValue = data
    },
    changeParameter (data) {
      this.volume_parameter = data
    },
    makeTable () { // this.mainData.productType = 3 (GENCO) || this.mainData.productType = 2 (DG)
      let table = []
      const type = this.totalValue >= 13 ? 'Green' : (this.totalValue > 9) ? 'Yellow' : 'Red'

      /// LCL - IMPORT - GENCO ///
      if (this.mainData.shipment === 'import' && this.mainData.productType === '3' && this.volume_parameter === 'CBM') {
        const totalStorage = parseInt(this.mainData.shipmentVolume) < 2 ? 8500 * 2 * this.mainData.expectedDays : 8500 * parseInt(this.mainData.shipmentVolume) * this.mainData.expectedDays
        const totalBehandle = type === 'Red' ? 37000 * parseInt(this.mainData.shipmentVolume) : 0
        const totalSurcharge = parseInt(this.mainData.shipmentVolume) >= 5 ? 26000 * parseInt(this.mainData.shipmentVolume) : 0
        const totalAdmin = 105000

        table.push(
          {
            description: 'Storage',
            basicRates: 8500,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          },
          {
            description: 'Behandle',
            basicRates: 37000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalBehandle
          },
          {
            description: 'Surcharge',
            basicRates: 26000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalSurcharge
          },
          {
            description: 'Admin',
            basicRates: 105000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalAdmin
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage + totalBehandle + totalSurcharge + totalAdmin
      }

      /// LCL - IMPORT - DG ///
      if (this.mainData.shipment === 'import' && this.mainData.productType === '2' && this.volume_parameter === 'CBM') {
        const totalStorage = parseInt(this.mainData.shipmentVolume) < 2 ? 35000 * 2 * this.mainData.expectedDays : 35000 * parseInt(this.mainData.shipmentVolume) * this.mainData.expectedDays
        const totalDGCharge = 550000
        const totalBehandle = type === 'Red' ? 40000 * parseInt(this.mainData.shipmentVolume) : 0
        const totalSurcharge = parseInt(this.mainData.shipmentVolume) >= 5 ? 35000 * parseInt(this.mainData.shipmentVolume) : 0
        const totalAdmin = 150000

        table.push(
          {
            description: 'Storage',
            basicRates: 35000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          },
          {
            description: 'WH DG Charge',
            basicRates: 550000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalDGCharge
          },
          {
            description: 'Behandle',
            basicRates: 40000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalBehandle
          },
          {
            description: 'Surcharge',
            basicRates: 35000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalSurcharge
          },
          {
            description: 'Admin',
            basicRates: 150000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalAdmin
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage + totalBehandle + totalSurcharge + totalAdmin + totalDGCharge
      }

      /// LCL - EXPORT - GENCO || DG ///
      if (this.mainData.shipment === 'export' && this.volume_parameter === 'CBM') {
        const totalStorage = parseInt(this.mainData.shipmentVolume) < 3 ? 7725 * 3 * this.mainData.expectedDays : 7725 * parseInt(this.mainData.shipmentVolume) * this.mainData.expectedDays
        const totalStorageDG = parseInt(this.mainData.shipmentVolume) < 3 ? 31000 * 3 * this.mainData.expectedDays : 31000 * parseInt(this.mainData.shipmentVolume) * this.mainData.expectedDays
        table.push(
          {
            description: 'Storage',
            basicRates: this.mainData.productType === '3' ? 7725 : 31000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: this.mainData.productType === '3' ? totalStorage : totalStorageDG
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = this.mainData.productType === '3' ? totalStorage : totalStorageDG
      }

      /// FCL - IMPORT - GENCO - 20ft || 40ft ///
      if (this.mainData.shipment === 'import' && this.mainData.productType === '3' && this.volume_parameter === 'Ctn') {
        const totalStorage = this.mainData.shipmentType === '20ft' ? (30000 * 3 * parseInt(this.mainData.shipmentVolume)) + (30000 * 6 * parseInt(this.mainData.shipmentVolume)) + (30000 * 3 * parseInt(this.mainData.shipmentVolume) * (this.mainData.expectedDays - 3))
          : (60000 * 3 * parseInt(this.mainData.shipmentVolume)) + (60000 * 6 * parseInt(this.mainData.shipmentVolume)) + (60000 * 3 * parseInt(this.mainData.shipmentVolume) * (this.mainData.expectedDays - 3))

        table.push(
          {
            description: this.mainData.shipmentType === '20ft' ? `Storage (20')` : `Storage (40')`,
            basicRates: this.mainData.shipmentType === '20ft' ? 30000 : 60000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage
      }

      /// FCL - IMPORT - DG - 20ft || 40ft ///
      if (this.mainData.shipment === 'import' && this.mainData.productType === '2' && this.volume_parameter === 'Ctn') {
        const totalStorage = this.mainData.shipmentType === '20ft' ? (250000 * 3 * parseInt(this.mainData.shipmentVolume)) + (250000 * 6 * parseInt(this.mainData.shipmentVolume)) + (250000 * 3 * parseInt(this.mainData.shipmentVolume) * (this.mainData.expectedDays - 3))
          : (500000 * 3 * parseInt(this.mainData.shipmentVolume)) + (500000 * 6 * parseInt(this.mainData.shipmentVolume)) + (500000 * 3 * parseInt(this.mainData.shipmentVolume) * (this.mainData.expectedDays - 3))
        const totalDGCharge = this.mainData.shipmentType === '20ft' ? 1100000 : 2200000
        table.push(
          {
            description: this.mainData.shipmentType === '20ft' ? `Storage (20')` : `Storage (40')`,
            basicRates: this.mainData.shipmentType === '20ft' ? 250000 : 500000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          },
          {
            description: this.mainData.shipmentType === '20ft' ? `WH DG Charge (20')` : `WH DG Charge (40')`,
            basicRates: this.mainData.shipmentType === '20ft' ? 1100000 : 2200000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalDGCharge
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage + totalDGCharge
      }

      /// FCL - EXPORT - GENCO - 20ft || 40ft ///
      if (this.mainData.shipment === 'export' && this.mainData.productType === '3' && this.volume_parameter === 'Ctn') {
        const x = this.mainData.expectedDays === 6 ? 2 : this.mainData.expectedDays === 9 ? 8 : this.mainData.expectedDays > 9 ? 10 : 0
        const y = this.mainData.expectedDays > 9 ? this.mainData.expectedDays - 10 : 0
        const totalStorage = this.mainData.shipmentType === '20ft' ? (30000 * parseInt(this.mainData.shipmentVolume)) + (30000 * parseInt(this.mainData.shipmentVolume) * x) + (30000 * parseInt(this.mainData.shipmentVolume) * 4 * y)
          : (60000 * parseInt(this.mainData.shipmentVolume)) + (60000 * parseInt(this.mainData.shipmentVolume) * x) + (60000 * parseInt(this.mainData.shipmentVolume) * 4 * y)

        table.push(
          {
            description: this.mainData.shipmentType === '20ft' ? `Storage (20')` : `Storage (40')`,
            basicRates: this.mainData.shipmentType === '20ft' ? 30000 : 60000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage
      }

      /// FCL - EXPORT - DG - 20ft || 40ft ///
      if (this.mainData.shipment === 'export' && this.mainData.productType === '2' && this.volume_parameter === 'Ctn') {
        const x = this.mainData.expectedDays === 6 ? 2 : this.mainData.expectedDays === 9 ? 8 : this.mainData.expectedDays > 9 ? 10 : 0
        const y = this.mainData.expectedDays > 9 ? this.mainData.expectedDays - 10 : 0
        const totalStorage = this.mainData.shipmentType === '20ft' ? (60000 * parseInt(this.mainData.shipmentVolume)) + (60000 * parseInt(this.mainData.shipmentVolume) * x) + (60000 * parseInt(this.mainData.shipmentVolume) * 4 * y)
          : (120000 * parseInt(this.mainData.shipmentVolume)) + (120000 * parseInt(this.mainData.shipmentVolume) * x) + (120000 * parseInt(this.mainData.shipmentVolume) * 4 * y)

        table.push(
          {
            description: this.mainData.shipmentType === '20ft' ? `Storage (20')` : `Storage (40')`,
            basicRates: this.mainData.shipmentType === '20ft' ? 60000 : 120000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage
      }

      /// AIR - IMPORT - DG || GENCO ///
      if (this.mainData.shipment === 'import' && this.volume_parameter === 'Kg') {
        const totalStorage = this.mainData.productType === '3' ? (3000 * this.mainData.shipmentVolume) + (3000 * this.mainData.shipmentVolume * (this.mainData.expectedDays - 3))
          : (6000 * this.mainData.shipmentVolume) + (6000 * this.mainData.shipmentVolume * (this.mainData.expectedDays - 3))

        table.push(
          {
            description: 'Storage',
            basicRates: this.mainData.productType === '3' ? 3000 : 6000,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage
      }

      /// AIR - EXPORT - DG || GENCO ///
      if (this.mainData.shipment === 'export' && this.volume_parameter === 'Kg') {
        const totalStorage = this.mainData.productType === '3' ? (1750 * this.mainData.shipmentVolume) + (1750 * this.mainData.shipmentVolume * (this.mainData.expectedDays - 3))
          : (3500 * this.mainData.shipmentVolume) + (3500 * this.mainData.shipmentVolume * (this.mainData.expectedDays - 3))

        table.push(
          {
            description: 'Storage',
            basicRates: this.mainData.productType === '3' ? 1750 : 3500,
            volume: parseInt(this.mainData.shipmentVolume),
            type: type,
            days: totalStorage
          }
        )
        this.resultCalculator.table = table
        this.resultCalculator.total = totalStorage
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/view/storageCalculator/index.vue